import { forwardRef, useMemo } from 'react';
import { FixedSizeList } from 'react-window';
import { useListNavigationContext } from './ListNavigationContext';
import { useEntityImageListSync } from '../../components/entityImage/entityImageListSync';

/**
 * Same react-window list, with the saved pixel offset applied on first mount.
 * Views already under ListNavigationProvider can swap this in for FixedSizeList.
 */
export const PersistedFixedSizeList = forwardRef(function PersistedFixedSizeList(props, ref) {
    const navigation = useListNavigationContext();
    const photoRevision = useEntityImageListSync();
    const initialScrollOffset = props.initialScrollOffset ?? navigation?.initialScrollOffset ?? 0;
    const itemData = useMemo(() => {
        if (!props.itemData || typeof props.itemData !== 'object') {
            return props.itemData;
        }
        return { ...props.itemData, __entityImageRev: photoRevision };
    }, [props.itemData, photoRevision]);
    return (
        <FixedSizeList
            {...props}
            itemData={itemData}
            ref={ref}
            initialScrollOffset={initialScrollOffset}
        />
    );
});
